import React, { useEffect, useState } from 'react'

import styles from './Lightbox.module.css'

interface LightboxProps {
  children?: React.ReactNode
  onClose?: () => void
  showOnLoad?: boolean
  style?: React.CSSProperties
}

const Lightbox: React.FC<LightboxProps> = ({
  children,
  onClose,
  showOnLoad = true,
}) => {
  const [isOpen, setIsOpen] = useState(showOnLoad)

  useEffect(() => {
    setIsOpen(showOnLoad)
  }, [showOnLoad])

  const handleClose = () => {
    setIsOpen(false)
    if (onClose) onClose()
  }

  if (!isOpen) return null

  return (
    <div className={`${styles.overlay} }`}>
      <div className={styles.lightbox}>
        <button
          className={styles.closeBtn}
          onClick={handleClose}
          aria-label="Close lightbox"
        >
          &times;
        </button>
        {children}
      </div>
    </div>
  )
}

export default Lightbox
